// extracted by mini-css-extract-plugin
export default {"rating":"_v-z","numberOfStars":"aw-z","count":"bw-z","barGraphSpacing":"cw-z","barGraph":"dw-z"};